import { memo, type FC } from "react"
import Box from "@mui/material/Box"

import GridCell from "./GridCell"

interface SpanCellProps {
  spanIndex: number
  spanId: number | null
  color: string
  isHovered: boolean
  isSelected: boolean
  isDimmed: boolean
  onEnter: (spanIndex: number, spanId: number | null) => void
  onLeave: () => void
  onSelect: (spanId: number | null) => void
}

const SpanCell: FC<SpanCellProps> = ({
  spanIndex,
  spanId,
  color,
  isHovered,
  isSelected,
  isDimmed,
  onEnter,
  onLeave,
  onSelect,
}) => (
  <GridCell sx={{ cursor: "pointer", zIndex: isHovered ? 2 : 1 }}>
    <Box
      data-testid="span-cell"
      onMouseEnter={() => onEnter(spanIndex, spanId)}
      onMouseLeave={onLeave}
      onClick={() => onSelect(spanId)}
      sx={{
        height: "100%",
        width: "100%",
        bgcolor: color,
        opacity: isDimmed ? 0.4 : 1,
        borderRadius: "2px",
        boxShadow: isSelected ? "0 0 0 1px rgba(255,255,255,0.9)" : "none",
        transform: isHovered ? "scaleY(1.15)" : "none",
        transformOrigin: "center",
        transition: "transform 0.1s ease",
      }}
    />
  </GridCell>
)

export default memo(SpanCell)
